import { useContext, useMemo } from 'react';
import { BrandThemingContext } from '@trinity/chat-components/containers/Branding/Context.js';
import { useOptionsColors } from '@/components/SurveyResponses/hooks/usePaletteColors';

/**
 * Hook for getting chart colors based on selected theme and manual overrides.
 * If a themeId is selected, uses colors from that theme palette.
 * Falls back to the group-default options colors.
 */
export const useChartColors = (selectedThemeId: number | null): string[] => {
  const { data } = useContext(BrandThemingContext);
  const defaultColors = useOptionsColors();

  return useMemo(() => {
    let base = defaultColors;

    if (selectedThemeId) {
      for (const categoryGroup of data.categories) {
        const theme = categoryGroup.items.find((item) => item.id === selectedThemeId);
        if (theme) {
          base = theme.colors;
          break;
        }
      }
    }

    return base;
  }, [selectedThemeId, data.categories, defaultColors]);
};
